import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { api } from "../../lib/api";
import { useToast } from "../../hooks/use-toast";
import { ShieldCheck, ShieldOff, Loader2 } from "lucide-react";

export default function PortalMfa() {
  const { toast } = useToast();
  const [mfa, setMfa] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/employee-portal/mfa").then((r) => setMfa(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/employee-portal/mfa/toggle");
      setMfa(data);
      toast({ title: data.enabled ? "MFA enabled" : "MFA disabled" });
    } finally { setBusy(false); }
  };

  if (!mfa) return <div className="h-40 rounded-xl bg-muted/40 animate-pulse" />;

  return (
    <div className="space-y-4 max-w-lg" data-testid="portal-mfa">
      <h1 className="text-xl font-semibold">Multi-Factor Authentication</h1>
      <Card>
        <CardContent className="p-6 flex flex-col items-center gap-4 text-center">
          {mfa.enabled ? (
            <ShieldCheck className="w-12 h-12 text-emerald-500" />
          ) : (
            <ShieldOff className="w-12 h-12 text-muted-foreground" />
          )}
          <div>
            <div className="text-[15px] font-semibold">{mfa.enabled ? "MFA is enabled" : "MFA is not enabled"}</div>
            <p className="text-[13px] text-muted-foreground mt-1">
              {mfa.enabled
                ? `Protecting your account via ${mfa.method}.`
                : "Add a second factor to protect your account from password-only attacks."}
            </p>
          </div>
          <Button onClick={toggle} disabled={busy} variant={mfa.enabled ? "outline" : "default"} data-testid="portal-mfa-toggle-btn">
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : mfa.enabled ? "Disable MFA" : "Enable MFA"}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
